class SacksyStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const section = this.closest('.shopify-section');
    const mainBuyButtons = section?.querySelector('.buy-buttons-block');

    if (!mainBuyButtons) return;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.toggleAttribute('inert', !shouldShow);
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        this.dataset.visible = shouldShow ? 'true' : 'false';
      },
      { threshold: 0 }
    );

    this.#observer.observe(mainBuyButtons);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('sacksy-sticky-atc')) {
  customElements.define('sacksy-sticky-atc', SacksyStickyAtc);
}
